$(document).ready(function () {
    "use strict";

    $('.openingBlock .js_showHideOpening').on('click', function () {

        $(this).siblings().find('.toggleMe').hide();
        $(this).siblings().removeClass('open');

        $(this).find('.toggleMe').stop(true, true).slideToggle();
        $(this).toggleClass('open');
    });
});